import Os from './os';

export default {
  Os,
};
